export class ComparisonTableItemTypeValueModel {
    private readonly _valueId: number;
    private readonly _valueName: string;

    constructor(value: {
        valueId: number,
        valueName: string
    }) {
        this._valueId = value.valueId;
        this._valueName = value.valueName;
    }

    /**
     * @property valueId
     * @description The unique identifier of the specification type value.
     * @returns {number}
     */
    public get valueId(): number {
        return this._valueId;
    }

    /**
     * @property valueName
     * @description The name of the specification type value.
     * @returns {string}
     */
    public get valueName(): string {
        return this._valueName;
    }
}